import { jsx as _jsx } from "react/jsx-runtime";
import { CalculateBirthTimeModal, Modal } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
const CalculateBirthTimeModalForm = ({ open, onClose, transmittedValues, }) => {
    const lastMenstruationDate = new Date();
    return (_jsx(Modal, Object.assign({ open: open, size: "xs", onClose: onClose }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: {
                lastMenstruationDate,
                menstruationCycleLength: 28,
            }, mutation: ({ lastMenstruationDate, menstruationCycleLength }) => transmittedValues(lastMenstruationDate, menstruationCycleLength), resetOnSuccess: true }, { children: ({ submitForm, isSuccess }) => (_jsx(CalculateBirthTimeModal, { isSuccess: isSuccess, onClose: onClose, onSubmitPress: submitForm })) })) })));
};
export default CalculateBirthTimeModalForm;
